<template>
    <b-card>
        <!-- Details Dialog -->
        <export-details-dialog :query-data="queryModel" ref="detailsDialog" />

        <b-card-header>
            <b-row class="mb-2">
                <b-col>
                    <customer-type-ahead v-model="model.customer_id" />
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="3">
                    <b-button
                        variant="light"
                        @click="toggle_controls = !toggle_controls"
                    >
                        Filters
                        <b-icon
                            :icon="
                                'chevron-' + (toggle_controls ? 'up' : 'down')
                            "
                            variant="dark"
                        ></b-icon>
                    </b-button>
                </b-col>
                <b-col>
                    <order-date-range v-model="dateRangeIdx" />
                </b-col>
                <b-col cols="3" style="text-align: right">
                    <b-button
                        variant="primary"
                        v-if="hasPermissionView"
                        @click="showDetailsDialog()"
                        :disabled="orders.length === 0"
                        >Report</b-button
                    >
                </b-col>
            </b-row>

            <report-query-builder
                v-model="model"
                :drivers="drivers"
                :order-types="orderTypes"
                v-show="toggle_controls"
            ></report-query-builder>
        </b-card-header>

        <b-card-body>
            <b-table responsive :fields="fields" :items="orders.slice(0, 24)">
            </b-table>
        </b-card-body>
    </b-card>
</template>
<script>
import CustomerTypeAhead from '@/components/CustomerTypeAhead.vue'
import OrderDateRange from '@/components/OrderDateRange'
import moment from 'moment'
import ExportDetailsDialog from './ExportDetailsDialog'
import ReportQueryBuilder from './ReportQueryBuilder'
import permissionsMixins from '@/mixins/permissionsMixins'

const dateRangeEnum = {
    today: 0,
    yesterday: 1,
    custom: 2,
}

export default {
    components: {
        CustomerTypeAhead,
        ExportDetailsDialog,
        OrderDateRange,
        ReportQueryBuilder,
    },
    name: 'reports-table',
    mixins: [permissionsMixins],
    props: {
        type: {
            type: String,
        },
        title: String,
    },
    data() {
        return {
            placement: 'top',
            dateRangeIdx: 2,
            toggle_controls: false,
            query: '',
            page: 1,
            model: {
                driver_id: 0,
                customer_id: 0,
                reference_no: 0,
                completed: 'any',
                order_type_id: 0,
                created_start: moment().startOf('month').format('YYYY-MM-DD'),
                created_end: moment().endOf('month').format('YYYY-MM-DD'),
                updated_at: moment().startOf('month').format('YYYY-MM-DD'),
                is_updated: 'any',
            },
            fields: [
                'customer',
                'reference_no',
                { key: 'driver', label: 'Officer' },
                'type',
                'completed',
                'created_at',
                'created_by',
            ],
        }
    },

    created() {
        this.$store.dispatch('orderType/fetchAll')
        this.$store.dispatch('report/fetchDrivers')
    },

    mounted() {
        this.$store.dispatch('report/fetch', this.queryModel)
    },

    methods: {
        showDetailsDialog() {
            this.$refs.detailsDialog.show(this.queryModel)
        },
        setModel(orders) {
            console.log('orders', orders)
        },
    },

    computed: {
        orderTypes() {
            return [{ name: 'Any', id: 0 }].concat(
                this.$store.state.orderType.items
            )
        },
        drivers() {
            return this.$store.state.report.drivers
        },

        customers() {
            return this.$store.state.report.customers
        },
        orders() {
            const orders = this.$store.state.report.items
            console.log('orders', orders)
            return orders
        },

        queryModel() {
            return {
                ...this.model,
                completed:
                    this.model.completed == 'any'
                        ? null
                        : this.model.completed == 'yes'
                        ? 1
                        : 0,
                type: this.model.type == 'any' ? null : this.model.type,
            }
        },
        dateObject() {
            return {
                today: {
                    created_start: moment().format('YYYY-MM-DD'),
                    created_end: moment().format('YYYY-MM-DD'),
                },
                yesterday: {
                    created_start: moment()
                        .subtract(1, 'days')
                        .format('YYYY-MM-DD'),
                    created_end: moment()
                        .subtract(1, 'days')
                        .format('YYYY-MM-DD'),
                },
                custom: {
                    created_start: '2020-01-01',
                    created_end: moment().format('YYYY-MM-DD'),
                },
            }
        },
    },

    watch: {
        /* 'model.customer_id': function (val) {
            console.log('customer', val)
            //  this.$store.dispatch('report/fetch', this.queryModel)
        }, */
        dateRangeIdx: function (_dateRangeIdx) {
            switch (_dateRangeIdx) {
                case dateRangeEnum.today:
                    this.model.created_start = moment().format('YYYY-MM-DD')
                    this.model.created_end = moment().format('YYYY-MM-DD')
                    break
                case dateRangeEnum.yesterday:
                    this.model.created_start = moment()
                        .subtract(1, 'days')
                        .format('YYYY-MM-DD')
                    this.model.created_end = moment()
                        .subtract(1, 'days')
                        .format('YYYY-MM-DD')
                    break
                default:
                    break
            }
        },

        model: {
            handler: function (val) {
                let { created_start, created_end } = val
                console.log('customer', val)
                if (
                    created_start === this.dateObject.today.created_start &&
                    created_end === this.dateObject.today.created_end
                ) {
                    this.dateRangeIdx = 0
                } else if (
                    created_start === this.dateObject.yesterday.created_start &&
                    created_end === this.dateObject.yesterday.created_end
                ) {
                    this.dateRangeIdx = 1
                } else {
                    this.dateRangeIdx = 2
                }
                this.$store.dispatch('report/fetch', this.queryModel)
            },
            deep: true,
        },
    },
}
</script>
<style>
.autocomplete input {
    border-radius: 0;
}
</style>
